export enum AlbumState {
  Draft = 'Draft',
  UnderReview = 'UnderReview',
  PendingImport = 'PendingImport',
  Rejected = 'Rejected',
  Released = 'Released',
  Error = 'Error',
}
